import {Dispatcher} from 'flux';

const AppDispatcher = Object.assign(new Dispatcher(), {
  handleServerAction(action) {
    this.dispatch({
      source: 'SERVER_ACTION',
      action,
    });
  },

  handleViewAction(action) {
    this.dispatch({
      source: 'VIEW_ACTION',
      action,
    });
  },
});

export default AppDispatcher;
